import React from 'react';
import RacePagination from '../../../common/pagination/racePagination';

interface RaceTimePaginationProperties {
	currentPage: number;
	maxPages: number;
	setCurrentPage: (newIndex: number) => void;
}

export default function RaceTimePagination({
	maxPages,
	currentPage,
	setCurrentPage,
}: RaceTimePaginationProperties) {
	return (
		<RacePagination
			maxPages={Math.max(maxPages, 1)}
			currentPage={currentPage}
			setCurrentPage={setCurrentPage}
			raceType="blindKaizo"
		/>
	);
}
